import { useEffect, useMemo, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { FerramentasDeDetalhe } from "../../shered/components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { VForm, useVForm } from "../../shered/forms";
import { Box, Tab, Tabs, Paper, Typography, useTheme, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import Grid from '@mui/material/Grid2';
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { IDetalheJogadorFreeAgency, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { ILstDrop, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { Loading } from "../../shered/components/loading/Loading";
import { ptBR } from '@mui/x-data-grid/locales';
import { EstatisticasService, IDadosClassificacaoHistorica, IDadosClassificacaoHistoricaFinal } from "../../shered/services/api/estatisticas/EstatisticasService";

let temporadaAtual = 0;
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ? 
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {
                // value === index && (
                <Box sx={{ p: 1 }}>
                    <Grid container>{children}</Grid>
                </Box>
                //)
            }
        </div>
         : ""}
        </>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}




export const ListagemDeClassificacaoHistorica: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const { themeName } = useAppThemeContext();
    const { formRef, save, saveAndClose } = useVForm();
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [codigoFranquia, setCodigoFranquia] = useState(localStorage.getItem("@codigoFranquia"));
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [semImagemFranquia, setSemImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [semImagem, setSemImagem] = useState<any>("../../semimagem.png");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [nomePrimeiraConferencia, setNomePrimeiraConferencia] = useState("");
    const [nomeSegundaConferencia, setNomeSegundaConferencia] = useState("");

    //const [lstJogadores, setLstJogadores] = useState<TDropOptions[]>([]);
    //const [jogadorSelecionado, setJogadorSelecionado] = useState<number>(0);
    const [valorSalarioJogador, setValorSalarioJogador] = useState<string>("");
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [anoSelecionado, setAnoSelecionado] = useState<number>(0);
    const [value, setValue] = useState(0);
    const [codigoTemporadaAtual, setCodigoTemporadaAtual] = useState(0);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [classificacaoGeralrows, setClassificacaoGeralrows] = useState<IDadosClassificacaoHistoricaFinal[]>([]);

    const [rowsConferencia1, setRowsConferencia1] = useState<IDadosClassificacaoHistoricaFinal[]>([]);
    const [rowsConferencia2, setRowsConferencia2] = useState<IDadosClassificacaoHistoricaFinal[]>([]);


    const [geral, setGeral] = useState<IDadosClassificacaoHistorica>();
    const [conferencia, setConferencia] = useState<IDadosClassificacaoHistorica[]>([]);
    //const [divisao, setDivisao] = useState<IDadosClassificacaoHistorica[]>([]);

    const [divisao0FranquiasRows, setDivisao0FranquiasRows] = useState<IDadosClassificacaoHistoricaFinal[]>([]);
    const [divisao1FranquiasRows, setDivisao1FranquiasRows] = useState<IDadosClassificacaoHistoricaFinal[]>([]);
    const [divisao2FranquiasRows, setDivisao2FranquiasRows] = useState<IDadosClassificacaoHistoricaFinal[]>([]);
    const [divisao3FranquiasRows, setDivisao3FranquiasRows] = useState<IDadosClassificacaoHistoricaFinal[]>([]);
    const [divisao4FranquiasRows, setDivisao4FranquiasRows] = useState<IDadosClassificacaoHistoricaFinal[]>([]);
    const [divisao5FranquiasRows, setDivisao5FranquiasRows] = useState<IDadosClassificacaoHistoricaFinal[]>([]);
    const [divisao6FranquiasRows, setDivisao6FranquiasRows] = useState<IDadosClassificacaoHistoricaFinal[]>([]);
    const [divisao7FranquiasRows, setDivisao7FranquiasRows] = useState<IDadosClassificacaoHistoricaFinal[]>([]);
    const [divisao8FranquiasRows, setDivisao8FranquiasRows] = useState<IDadosClassificacaoHistoricaFinal[]>([]);

    const [nomeDivisao0, setNomeDivisao0] = useState("");
    const [nomeDivisao1, setNomeDivisao1] = useState("");
    const [nomeDivisao2, setNomeDivisao2] = useState("");
    const [nomeDivisao3, setNomeDivisao3] = useState("");
    const [nomeDivisao4, setNomeDivisao4] = useState("");
    const [nomeDivisao5, setNomeDivisao5] = useState("");
    const [nomeDivisao6, setNomeDivisao6] = useState("");
    const [nomeDivisao7, setNomeDivisao7] = useState("");
    const [nomeDivisao8, setNomeDivisao8] = useState("");
    const [tipoFiltro, setTipoFiltro] = useState(1);

    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const columns: GridColDef[] = [
        {
            field: 'codigo', headerName: '',
            flex: 1,
            minWidth: 33,
            // maxWidth: 40,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: tipoFiltro === 1 ? 'logo' : 'foto',
            headerName: '',
            hideable: false,
            minWidth: UtilidadeService.isMobile() ? 45 : 65,
            // maxWidth: 65,
            flex: 1,
            renderCell: (params) => <img src={params.value !== null ? params.value : tipoFiltro === 1 ? semImagemFranquia : semImagem} width={UtilidadeService.isMobile() ? 25 : 45} height={UtilidadeService.isMobile() ? 30 : 50} />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'nome',
            headerName: 'NOME',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{

                            fontWeight: 'bold',
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'vitoria',
            headerName: 'V',
            headerClassName: 'super-app-theme--header',
            editable: false,
            flex: 1,
            minWidth: 35,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'empate',
            headerName: 'E',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 35,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'derrota',
            headerName: 'D',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 35,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'aproveitamento',
            headerName: 'APROVEITAMENTO %',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 190,
            //   maxWidth: 55,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(3).replace(".", ",") : "0"
        }
    ];

    const columnsDivs: GridColDef[] = [
        {
            field: 'codigo', headerName: '',
            flex: 1,
            minWidth: 33,
            // maxWidth: 40,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: tipoFiltro === 1 ? 'logo' : 'foto',
            headerName: '',
            hideable: false,
            minWidth: UtilidadeService.isMobile() ? 45 : 65,
            // maxWidth: 65,
            flex: 1,
            renderCell: (params) => <img src={params.value !== null ? params.value : tipoFiltro === 1 ? semImagemFranquia : semImagem} width={UtilidadeService.isMobile() ? 25 : 45} height={UtilidadeService.isMobile() ? 30 : 50} />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },        
        {
            field: 'nome',
            headerName: 'NOME',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{

                            fontWeight: 'bold',
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'vitoria',
            headerName: 'V',
            headerClassName: 'super-app-theme--header',
            editable: false,
            flex: 1,
            minWidth: 45,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'empate',
            headerName: 'E',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 45,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'derrota',
            headerName: 'D',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 45,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'aproveitamento',
            headerName: '%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 110,
            //   maxWidth: 55,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(3).replace(".", ",") : "0"
        }
    ];

    const columnsConfs: GridColDef[] = [
        {
            field: 'codigo', headerName: '',
            flex: 1,
            minWidth: 33,
            // maxWidth: 40,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: tipoFiltro === 1 ? 'logo' : 'foto',
            headerName: '',
            hideable: false,
            minWidth: UtilidadeService.isMobile() ? 45 : 65,
            // maxWidth: 65,
            flex: 1,
            renderCell: (params) => <img src={params.value !== null ? params.value : tipoFiltro === 1 ? semImagemFranquia : semImagem} width={UtilidadeService.isMobile() ? 25 : 45} height={UtilidadeService.isMobile() ? 30 : 50} />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },       
        {
            field: 'nome',
            headerName: 'NOME',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{

                            fontWeight: 'bold',
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'vitoria',
            headerName: 'V',
            headerClassName: 'super-app-theme--header',
            editable: false,
            flex: 1,
            minWidth: 45,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'empate',
            headerName: 'E',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 45,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'derrota',
            headerName: 'D',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 45,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'aproveitamento',
            headerName: '%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 110,
            //   maxWidth: 55,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(3).replace(".", ",") : "0"
        }
    ];

    useEffect(() => {

        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        setIsLoading(true);
        const fetchData = async () => {
            await UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const tmps = result.data.dado;
                    let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                    setLstTemporadas(lstTemporadasAux);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });

            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const liga = result.dado;
                    setDadosLiga(liga);
                    setCodigoTemporadaAtual(liga.codigo_Temporada);
                    CarregarClassificacoes(liga.codigo, 1);
                    temporadaAtual = liga.codigo_Temporada;
                    if (liga.caminho_Logo !== null) {
                        setShowImagemFranquia(liga.caminho_Logo);
                    }
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });
        }
        fetchData();
        setRemoveLoading(true);

    }, [codigoLiga]);   

    const handleSelectedTipoClassificacao = async (e: { target: { name: string; value: any; }; }) => {
        await CarregarClassificacoes(Number(codigoLiga), e.target.value);
    };

    const CarregarClassificacoes = async (codigoLiga: number, tipoFiltro: number) => {
        setIsLoading(true);
        setRemoveLoading(false);
        if (tipoFiltro === 1) {
            EstatisticasService.getClassificacaoHistoricaFranquiaPorCodigoLiga(codigoLiga)
                .then((result) => {
                    const dadosClassificacao = result.dado;                    
                    if (dadosClassificacao !== undefined && dadosClassificacao !== null) {
                        setGeral(dadosClassificacao.geral);
                        setClassificacaoGeralrows(dadosClassificacao.geral.classificacao);
                        setConferencia(dadosClassificacao.conferencia)
                        setRowsConferencia1(dadosClassificacao.conferencia === null ? [] : dadosClassificacao.conferencia[0].classificacao);
                        setNomePrimeiraConferencia(dadosClassificacao.conferencia === null ? "" : dadosClassificacao.conferencia[0].nome);
                        setRowsConferencia2(dadosClassificacao.conferencia === null ? [] : dadosClassificacao.conferencia[1].classificacao);
                        setNomeSegundaConferencia(dadosClassificacao.conferencia === null ? "" : dadosClassificacao.conferencia[1].nome);
                        const codConf1 = dadosClassificacao.conferencia[0].codigo;
                        const codConf2 = dadosClassificacao.conferencia[1].codigo;

                        dadosClassificacao.divisao.filter(f => f.codigo_Conferencia === codConf1).forEach((f, i) => {
                            eval(`setNomeDivisao${(i + 1)}(f.nome)`);
                            eval(`setDivisao${(i + 1)}FranquiasRows(f.classificacao !== undefined ? f.classificacao : [])`);
                        })

                        dadosClassificacao.divisao.filter(f => f.codigo_Conferencia === codConf2).forEach((f, i) => {
                            eval(`setNomeDivisao${(i + 5)}(f.nome)`);
                            eval(`setDivisao${(i + 5)}FranquiasRows(f.classificacao !== undefined ? f.classificacao : [])`);
                        });
                    }
                    setIsLoading(false);
                    setRemoveLoading(true);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados do relatórios! Favor tentar mais tarde e caso o problema persista, entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });
        }
        else {
            EstatisticasService.getClassificacaoHistoricaUsuarioPorCodigoLiga(codigoLiga)
                .then((result) => {
                    setValue(2);
                    const dadosClassificacao = result.dado;
                    if (dadosClassificacao !== undefined && dadosClassificacao !== null) {
                        setGeral(dadosClassificacao.geral)
                        setClassificacaoGeralrows(dadosClassificacao.geral.classificacao);
                        setConferencia([])
                        setRowsConferencia1([]);
                        setNomePrimeiraConferencia("");
                        setRowsConferencia2([]);
                        setNomeSegundaConferencia("");
                    }
                    setIsLoading(false);
                    setRemoveLoading(true);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados do relatórios! Favor tentar mais tarde e caso o problema persista, entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });
        }
    }

    const handleSave = async (dados: any) => {
        const liga = dadosLiga !== null && dadosLiga !== undefined ? dadosLiga : null;
        if (liga === null) {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }

        const dadosSalvar: IDetalheJogadorFreeAgency = {
            codigo_Franquia: liga?.codigo_Franquia,
            codigo_Free_Agency: liga?.codigo_Free_Agency,
            codigo_Jogador: Number(selectedIdComplete),
            tempo_Contrato: anoSelecionado,
            valor: valorSalarioJogador
        }

        JogadorService.CreateJogadorFreeAgency(dadosSalvar)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Lance salvo com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });
                setRedirecionar("0");
            })
            .catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível cadastrar os dados do lance! Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const handleDelete = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            // FranquiaService.deleteById(id)
            //     .then((result) => {
            //         setShowModalMensagem(true);
            //         setDadosModalMensagem({
            //             acao: true,
            //             label: "",
            //             tipo: "success",
            //             mensagem: "Registro excluido com sucesso!",
            //             display: "none",
            //             titulo: "Atenção"
            //         });
            //         setRedirecionar("/franquias");
            //     })
            //     .catch((errors) => {
            //         setShowModalMensagem(true);
            //         if (errors.response.data.statusHTTP === 401) {
            //             logout();
            //             setDadosModalMensagem({
            //                 acao: true,
            //                 label: "",
            //                 tipo: "error",
            //                 mensagem: "Sessão expirada!",
            //                 display: "none",
            //                 titulo: "Atenção"
            //             });
            //             setRedirecionar("0");;
            //             return;
            //         }
            //         setDadosModalMensagem({
            //             acao: true,
            //             label: "",
            //             tipo: "error",
            //             mensagem: errors.response.data.mensagem,
            //             display: "none",
            //             titulo: "Atenção"
            //         });
            //     });
        }
    }

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    }

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const pagina = useMemo(() => {
        return Number(searchParams.get("pagina") || "0");
    }, [searchParams]);


    return (
        <LayoutBaseDePagina
            titulo={`Aproveitamento da Liga - ${dadosLiga?.nome}`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoSalvar={false}
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmApagar={() => handleDelete(Number(codigoFranquia))}
                    aoClicarEmNovo={() => navigate("/freeagency/detalhe/nova")}
                    aoClicarEmVoltar={() => navigate(`/usuario/liga/${codLocal}`)}
                />
            }
        >
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    {classificacaoGeralrows.length > 0 ? (
                        <>
                            <Grid container size={{xs:12, sm:12}} direction="column" padding={2} spacing={2}>
                                <Grid  size={{xs:12, sm:12}} >
                                    <Typography variant="h6">Aproveitamento da Liga</Typography>
                                    <hr />
                                </Grid>
                                <Grid container size={{xs:12, sm:12}} display="flex" justifyContent="initial">
                                    <Grid  size={{xs:12, sm:6, md:3}} >
                                        <FormControl fullWidth disabled={isLoading}>
                                            <InputLabel id="demo-simple-select-label">TIPO</InputLabel>
                                            <Select
                                                variant="outlined"
                                                native={false}
                                                value={tipoFiltro}
                                                label="Tipo"
                                                onChange={(e) => { setTipoFiltro(Number(e.target.value)); handleSelectedTipoClassificacao(e) }}
                                            >
                                                <MenuItem value={1}>FRANQUIAS</MenuItem>
                                                <MenuItem value={2}>GENERAL MANAGER (GM)</MenuItem>
                                            </Select>
                                        </FormControl >
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container size={{xs:12, sm:12}} direction="column" padding={2} spacing={2}>
                                <Grid  size={{xs:12, sm:12}} alignItems="center" justifyContent="center" width="100%">
                                    <Paper>
                                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                            <Tabs value={value} onChange={handleChangeTabs} centered variant="fullWidth">
                                                <Tab label="Conferência" disabled={tipoFiltro === 2} {...a11yProps(0)} />
                                                <Tab label="Divisão" disabled={tipoFiltro === 2} {...a11yProps(1)} />
                                                <Tab label="Liga"  {...a11yProps(2)} />
                                            </Tabs>
                                        </Box>
                                        <TabPanel value={value} index={0} >
                                            {!removeLoading && <Loading />}
                                            <Grid container size={{xs:12, sm:12}} spacing={1} display="flex" padding={0}>
                                                <Grid container size={{xs:12, sm:6}} textAlign="initial" >
                                                    <Grid  size={{xs:12, sm:12, md:12}} >
                                                        <Typography variant="h6">{nomePrimeiraConferencia}</Typography>
                                                        <hr />
                                                    </Grid>

                                                    <Grid  size={{xs:12, sm:12}} style={{ width: "100%" }}>
                                                        <Grid  margin={1} paddingBottom={1}>
                                                            {!removeLoading && <Loading />}
                                                        </Grid>
                                                        <Box padding={0} sx={{

                                                            width: "100%",
                                                            height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                            '& .super-app-theme--header': {
                                                                backgroundColor: theme.palette.common.black,
                                                                color: theme.palette.common.white,
                                                            },
                                                            '& .super-app.negative': {
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .super-app.positive': {
                                                                color: themeName === "light" ? "black" : "auto",
                                                            },
                                                            '& .super-app-theme--cell': {
                                                                color: '#00e676',
                                                                fontWeight: '600',
                                                            },
                                                        }}>
                                                            <DataGrid
                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                getRowId={(r) => r.codigo}
                                                                rows={rowsConferencia1}
                                                                columns={columnsConfs}
                                                                initialState={{
                                                                    pagination: {
                                                                        paginationModel: {
                                                                            pageSize: 16,
                                                                            page: pagina,
                                                                        },
                                                                    },
                                                                }}
                                                                columnVisibilityModel={{
                                                                    codigo: false,
                                                                    //    logo_Franquia: UtilidadeService.isMobile() ? false : true
                                                                }}
                                                                pageSizeOptions={[16]}
                                                                disableRowSelectionOnClick
                                                                disableColumnFilter
                                                                disableColumnMenu
                                                                sx={{
                                                                    fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                }}

                                                            />
                                                        </Box>
                                                    </Grid>

                                                </Grid>
                                                <Grid container size={{xs:12, sm:6}} textAlign="initial" >
                                                    <Grid  size={{xs:12, sm:12, md:12}} >
                                                        <Typography variant="h6">{nomeSegundaConferencia}</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid  size={{xs:12, sm:12}}>
                                                        <Grid  margin={1} paddingBottom={1}>
                                                            {!removeLoading && <Loading />}
                                                        </Grid>
                                                        <Box sx={{
                                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                            '& .super-app-theme--header': {
                                                                backgroundColor: theme.palette.common.black,
                                                                color: theme.palette.common.white,
                                                            },
                                                            '& .super-app.negative': {
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .super-app.positive': {
                                                                color: themeName === "light" ? "black" : "auto",
                                                            },
                                                            '& .super-app-theme--cell': {
                                                                color: '#00e676',
                                                                fontWeight: '600',
                                                            },
                                                        }}>
                                                            <DataGrid
                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                getRowId={(r) => r.codigo}
                                                                rows={rowsConferencia2}
                                                                columns={columnsConfs}
                                                                initialState={{
                                                                    pagination: {
                                                                        paginationModel: {
                                                                            pageSize: 16,
                                                                            page: pagina,
                                                                        },
                                                                    },
                                                                }}

                                                                pageSizeOptions={[16]}
                                                                disableRowSelectionOnClick
                                                                disableColumnFilter
                                                                disableColumnMenu
                                                                columnVisibilityModel={{ codigo: false }}
                                                                sx={{
                                                                    fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                }}
                                                            />
                                                        </Box>
                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        </TabPanel>
                                        <TabPanel value={value} index={1}>
                                            <Grid container size={{xs:12, sm:12}}>
                                                <Grid container marginTop={1} size={{xs:12, sm:6}}>
                                                    {!removeLoading && <Loading />}
                                                    <Grid container size={{xs:12, sm:12}} padding={1}>
                                                        <Grid  size={{xs:12, sm:12}} >
                                                            <Typography variant="h6">{`${nomeDivisao1} (${nomePrimeiraConferencia})`}</Typography>
                                                            <hr />
                                                        </Grid>
                                                        <Grid  size={{xs:12, sm:12}}>
                                                            <Box sx={{
                                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                },
                                                                '& .super-app-theme--cell': {
                                                                    color: '#00e676',
                                                                    fontWeight: '600',
                                                                },
                                                            }}>
                                                                <DataGrid
                                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                    getRowId={(rows) => rows.codigo}
                                                                    rows={divisao1FranquiasRows}
                                                                    columns={columnsDivs}

                                                                    initialState={{
                                                                        pagination: {
                                                                            paginationModel: {
                                                                                pageSize: 16,
                                                                                page: pagina,
                                                                            },
                                                                        },
                                                                    }}
                                                                    pageSizeOptions={[16]}
                                                                    // //checkboxSelection
                                                                    disableRowSelectionOnClick
                                                                    disableColumnFilter
                                                                    disableColumnMenu
                                                                    columnVisibilityModel={{ codigo: false }}
                                                                    sx={{
                                                                        fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container size={{xs:12, sm:12}} padding={1}>
                                                        <Grid  size={{xs:12, sm:12}} >
                                                            <Typography variant="h6">{`${nomeDivisao2} (${nomePrimeiraConferencia})`}</Typography>
                                                            <hr />
                                                        </Grid>
                                                        <Grid  size={{xs:12, sm:12}} >
                                                            <Box sx={{
                                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                },
                                                                '& .super-app-theme--cell': {
                                                                    color: '#00e676',
                                                                    fontWeight: '600',
                                                                },
                                                            }}>
                                                                <DataGrid
                                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                    getRowId={(rows) => rows.codigo}
                                                                    rows={divisao2FranquiasRows}
                                                                    columns={columnsDivs}
                                                                    initialState={{
                                                                        pagination: {
                                                                            paginationModel: {
                                                                                pageSize: 16,
                                                                                page: pagina,
                                                                            },
                                                                        },
                                                                    }}
                                                                    pageSizeOptions={[16]}
                                                                    //checkboxSelection
                                                                    disableRowSelectionOnClick
                                                                    disableColumnFilter
                                                                    disableColumnMenu
                                                                    columnVisibilityModel={{ codigo: false }}
                                                                    sx={{
                                                                        fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                    {divisao3FranquiasRows.length > 0 && (
                                                        <Grid container size={{xs:12, sm:12}} padding={1}>
                                                            <Grid  size={{xs:12, sm:12}} >
                                                                <Typography variant="h6">{`${nomeDivisao3} (${nomePrimeiraConferencia})`}</Typography>
                                                                <hr />
                                                            </Grid>
                                                            <Grid  size={{xs:12, sm:12}} >
                                                                <Box sx={{
                                                                    height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                    '& .super-app-theme--header': {
                                                                        backgroundColor: theme.palette.common.black,
                                                                        color: theme.palette.common.white
                                                                    },
                                                                    '& .super-app.negative': {
                                                                        color: 'red',
                                                                        fontWeight: 'bold'
                                                                    },
                                                                    '& .super-app.positive': {
                                                                        color: themeName === "light" ? "black" : "auto",
                                                                    },
                                                                    '& .super-app-theme--cell': {
                                                                        color: '#00e676',
                                                                        fontWeight: '600',
                                                                    },
                                                                }}>
                                                                    <DataGrid
                                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                        getRowId={(rows) => rows.codigo}
                                                                        rows={divisao3FranquiasRows}
                                                                        columns={columnsDivs}
                                                                        initialState={{
                                                                            pagination: {
                                                                                paginationModel: {
                                                                                    pageSize: 16,
                                                                                    page: pagina,
                                                                                },
                                                                            },
                                                                        }}
                                                                        pageSizeOptions={[16]}
                                                                        //checkboxSelection
                                                                        disableRowSelectionOnClick
                                                                        disableColumnFilter
                                                                        disableColumnMenu
                                                                        columnVisibilityModel={{ codigo: false }}
                                                                        sx={{
                                                                            fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    )}
                                                    {divisao4FranquiasRows.length > 0 && (
                                                        <Grid container size={{xs:12, sm:12}} padding={1}>
                                                            <Grid  size={{xs:12, sm:12}} >
                                                                <Typography variant="h6">{`${nomeDivisao4} (${nomePrimeiraConferencia})`}</Typography>
                                                                <hr />
                                                            </Grid>
                                                            <Grid  size={{xs:12, sm:12}} >
                                                                <Box sx={{
                                                                    height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                    '& .super-app-theme--header': {
                                                                        backgroundColor: theme.palette.common.black,
                                                                        color: theme.palette.common.white
                                                                    },
                                                                    '& .super-app.negative': {
                                                                        color: 'red',
                                                                        fontWeight: 'bold'
                                                                    },
                                                                    '& .super-app.positive': {
                                                                        color: themeName === "light" ? "black" : "auto",
                                                                    },
                                                                    '& .super-app-theme--cell': {
                                                                        color: '#00e676',
                                                                        fontWeight: '600',
                                                                    },
                                                                }}>
                                                                    <DataGrid
                                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                        getRowId={(rows) => rows.codigo}
                                                                        rows={divisao4FranquiasRows}
                                                                        columns={columnsDivs}
                                                                        initialState={{
                                                                            pagination: {
                                                                                paginationModel: {
                                                                                    pageSize: 16,
                                                                                    page: pagina,
                                                                                },
                                                                            },
                                                                        }}
                                                                        pageSizeOptions={[16]}
                                                                        //checkboxSelection
                                                                        disableRowSelectionOnClick
                                                                        disableColumnFilter
                                                                        disableColumnMenu
                                                                        columnVisibilityModel={{ codigo: false }}
                                                                        sx={{
                                                                            fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                                <Grid container marginTop={1} size={{xs:12, sm:6}}>
                                                    {!removeLoading && <Loading />}
                                                    <Grid container size={{xs:12, sm:12}} padding={1} >
                                                        <Grid  size={{xs:12, sm:12}} >
                                                            <Typography variant="h6">{`${nomeDivisao5} (${nomeSegundaConferencia})`}</Typography>
                                                            <hr />
                                                        </Grid>
                                                        <Grid  size={{xs:12, sm:12}} >
                                                            <Box sx={{
                                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                },
                                                                '& .super-app-theme--cell': {
                                                                    color: '#00e676',
                                                                    fontWeight: '600',
                                                                },
                                                            }}>
                                                                <DataGrid
                                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                    getRowId={(rows) => rows.codigo}
                                                                    rows={divisao5FranquiasRows}
                                                                    columns={columnsDivs}
                                                                    initialState={{
                                                                        pagination: {
                                                                            paginationModel: {
                                                                                pageSize: 16,
                                                                                page: pagina,
                                                                            },
                                                                        },
                                                                    }}
                                                                    pageSizeOptions={[16]}
                                                                    //checkboxSelection
                                                                    disableRowSelectionOnClick
                                                                    disableColumnFilter
                                                                    disableColumnMenu
                                                                    columnVisibilityModel={{ codigo: false }}
                                                                    sx={{
                                                                        fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container size={{xs:12, sm:12}} padding={1}>
                                                        <Grid  size={{xs:12, sm:12}} >
                                                            <Typography variant="h6">{`${nomeDivisao6} (${nomeSegundaConferencia})`}</Typography>
                                                            <hr />
                                                        </Grid>
                                                        <Grid  size={{xs:12, sm:12}} >
                                                            <Box sx={{
                                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                },
                                                                '& .super-app-theme--cell': {
                                                                    color: '#00e676',
                                                                    fontWeight: '600',
                                                                },
                                                            }}>
                                                                <DataGrid
                                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                    getRowId={(rows) => rows.codigo}
                                                                    rows={divisao6FranquiasRows}
                                                                    columns={columnsDivs}
                                                                    initialState={{
                                                                        pagination: {
                                                                            paginationModel: {
                                                                                pageSize: 16,
                                                                                page: pagina,
                                                                            },
                                                                        },
                                                                    }}
                                                                    pageSizeOptions={[16]}
                                                                    //checkboxSelection
                                                                    disableRowSelectionOnClick
                                                                    disableColumnFilter
                                                                    disableColumnMenu
                                                                    columnVisibilityModel={{ codigo: false }}
                                                                    sx={{
                                                                        fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                    {divisao7FranquiasRows.length > 0 && (
                                                        <Grid container size={{xs:12, sm:12}} padding={1}>
                                                            <Grid  size={{xs:12, sm:12}} >
                                                                <Typography variant="h6">{`${nomeDivisao7} (${nomeSegundaConferencia})`}</Typography>
                                                                <hr />
                                                            </Grid>
                                                            <Grid  size={{xs:12, sm:12}} >
                                                                <Box sx={{
                                                                    height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                    '& .super-app-theme--header': {
                                                                        backgroundColor: theme.palette.common.black,
                                                                        color: theme.palette.common.white
                                                                    },
                                                                    '& .super-app.negative': {
                                                                        color: 'red',
                                                                        fontWeight: 'bold'
                                                                    },
                                                                    '& .super-app.positive': {
                                                                        color: themeName === "light" ? "black" : "auto",
                                                                    },
                                                                    '& .super-app-theme--cell': {
                                                                        color: '#00e676',
                                                                        fontWeight: '600',
                                                                    },
                                                                }}>
                                                                    <DataGrid
                                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                        getRowId={(rows) => rows.codigo}
                                                                        rows={divisao7FranquiasRows}
                                                                        columns={columnsDivs}
                                                                        initialState={{
                                                                            pagination: {
                                                                                paginationModel: {
                                                                                    pageSize: 16,
                                                                                    page: pagina,
                                                                                },
                                                                            },
                                                                        }}
                                                                        pageSizeOptions={[16]}
                                                                        //checkboxSelection
                                                                        disableRowSelectionOnClick
                                                                        disableColumnFilter
                                                                        disableColumnMenu
                                                                        columnVisibilityModel={{ codigo: false }}
                                                                        sx={{
                                                                            fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    )}
                                                    {divisao8FranquiasRows.length > 0 && (
                                                        <Grid container size={{xs:12, sm:12}} padding={1}>
                                                            <Grid  size={{xs:12, sm:12}} >
                                                                <Typography variant="h6">{`${nomeDivisao8} (${nomeSegundaConferencia})`}</Typography>
                                                                <hr />
                                                            </Grid>
                                                            <Grid  size={{xs:12, sm:12}} >
                                                                <Box sx={{
                                                                    height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                    '& .super-app-theme--header': {
                                                                        backgroundColor: theme.palette.common.black,
                                                                        color: theme.palette.common.white
                                                                    },
                                                                    '& .super-app.negative': {
                                                                        color: 'red',
                                                                        fontWeight: 'bold'
                                                                    },
                                                                    '& .super-app.positive': {
                                                                        color: themeName === "light" ? "black" : "auto",
                                                                    },
                                                                    '& .super-app-theme--cell': {
                                                                        color: '#00e676',
                                                                        fontWeight: '600',
                                                                    },
                                                                }}>
                                                                    <DataGrid
                                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                        getRowId={(rows) => rows.codigo}
                                                                        rows={divisao8FranquiasRows}
                                                                        columns={columnsDivs}
                                                                        initialState={{
                                                                            pagination: {
                                                                                paginationModel: {
                                                                                    pageSize: 16,
                                                                                    page: pagina,
                                                                                },
                                                                            },
                                                                        }}
                                                                        pageSizeOptions={[16]}
                                                                        //checkboxSelection
                                                                        disableRowSelectionOnClick
                                                                        disableColumnFilter
                                                                        disableColumnMenu
                                                                        columnVisibilityModel={{ codigo: false }}
                                                                        sx={{
                                                                            fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </TabPanel>
                                        <TabPanel value={value} index={2}>
                                            {!removeLoading && <Loading />}
                                            <Grid container size={{xs:12, sm:12}} direction="column" >
                                                <Box sx={{
                                                    height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                    '& .super-app-theme--header': {
                                                        backgroundColor: theme.palette.common.black,
                                                        color: theme.palette.common.white,
                                                    },
                                                    '& .super-app.negative': {
                                                        color: 'red',
                                                        fontWeight: 'bold'
                                                    },
                                                    '& .super-app.positive': {
                                                        color: themeName === "light" ? "black" : "auto",
                                                    },
                                                    '& .super-app-theme--cell': {
                                                        color: '#00e676',
                                                        fontWeight: '600',
                                                    },
                                                }}>
                                                    <DataGrid
                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                        getRowId={(geralRows) => geralRows.codigo}
                                                        rows={classificacaoGeralrows}
                                                        columns={columns}
                                                        initialState={{
                                                            pagination: {
                                                                paginationModel: {
                                                                    pageSize: 32,
                                                                    page: pagina,
                                                                },
                                                            },
                                                        }}
                                                        pageSizeOptions={[32]}
                                                        disableRowSelectionOnClick
                                                        disableColumnFilter
                                                        disableColumnMenu
                                                        columnVisibilityModel={{ codigo: false }}
                                                        sx={{
                                                            fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                        </TabPanel>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </>
                    )
                        :
                        <Grid container size={{xs:12, sm:12}} direction="column" padding={2} spacing={2}>
                            <Grid  size={{xs:12, sm:12}} >
                                <Typography variant="h6">Aproveitamento da Liga</Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{xs:12, sm:12}} direction="column" padding={2} spacing={2}>
                                <Grid  size={{xs:12, sm:12}} display="flex" justifyContent="flex-start" padding={1}>
                                    <Typography variant="body1">Informações não disponíveis!</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                </Box>
            </VForm>
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
        </LayoutBaseDePagina >
    );
};